import { createContext, useContext } from "react";

interface AppShellContextValue {
  hasShell: boolean;
  showSidebar: boolean;
}

const AppShellContext = createContext<AppShellContextValue>({
  hasShell: false,
  showSidebar: false,
});

export const AppShellProvider = AppShellContext.Provider;

export const useAppShell = () => useContext(AppShellContext);
